import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PnrAvailableOption } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-available-option-modal',
  templateUrl: './available-option-modal.component.html'
})
export class AvailableOptionModalComponent {
  @Input() action: PnrAvailableOption;
  @Input() showAlert: boolean = false;
  @Output() closeModal = new EventEmitter<boolean>();
}
